import { useQuery } from '@tanstack/react-query';

import { paymentService } from '@project/services';
import { PaymentIntentModel } from './payment-intent.model';

export const useGetPaymentIntentQuery = (
  enabledQuery: boolean,
  amount: string,
  currency: string,
  donationType: string,
  paymentType: string,
  eventId?: number,
  prayerRequests?: string,
  tipAmount?: string,
  sponsorMagazine?: string,
  paymentMethod?: string,
) =>
  useQuery(
    ['getPaymentIntent'],
    () =>
      paymentService.createIntent(
        eventId,
        amount,
        currency,
        donationType,
        paymentType,
        prayerRequests,
        tipAmount,
        sponsorMagazine,
        paymentMethod,
      ),
    {
      enabled: enabledQuery,
      select: PaymentIntentModel,
      staleTime: 0,
      cacheTime: 0,
    },
  );

export const useGetPaymentSubscriptionQuery = (
  enabledQuery: boolean,
  amount: string,
  currency: string,
  donationType: string,
  paymentType: string,
  eventId?: number,
  prayerRequests?: string,
  tipAmount?: string,
  sponsorMagazine?: string,
) =>
  useQuery(
    ['getPaymentSubscription'],
    () =>
      paymentService.createRecuringPayment(
        eventId,
        amount,
        currency,
        donationType,
        paymentType,
        prayerRequests,
        tipAmount,
        sponsorMagazine,
      ),
    {
      enabled: enabledQuery,
      staleTime: 0,
      cacheTime: 0,
      retry: false,
    },
  );
